import React from "react";

export const LoadingSkeleton = ({ showCtaBar }: { showCtaBar: boolean }) => (
    <div>
        <div
            id="real-time-balance-loading"
            className="bg-white p-32 rounded-16 s992:shadow-0-2-4-0 flex flex-col items-center"
        >
            <div className="flex justify-between w-full">
                <h3 className="h4 bg-white">{gettext("Total due")}</h3>
                <div className="bg-gray-f4f5f7 rounded-8 h-24 w-140 animate-pulse" />
            </div>
            <div className="bg-gray-f4f5f7 mt-24 rounded-8 h-48 w-full animate-pulse" />
            <div className="bg-gray-f4f5f7 mt-16 rounded-8 h-48 w-full animate-pulse" />
            <div className="bg-gray-f4f5f7 mt-16 rounded-8 h-24 w-160 animate-pulse" />
        </div>
        {showCtaBar && (
            <div className="flex justify-center mt-16">
                <div className="bg-gray-f4f5f7 rounded-8 w-300 h-24 animate-pulse" />
            </div>
        )}
    </div>
);
